import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs';
import { VisitService } from 'src/app/core/services/visit.service';
import { ToastService } from '../toast/toast.service';
import {TYPE_USER} from "../../../core/const/const";
import {UserService} from "../../../core/user/user.service";

@Component({
  selector: 'app-modal-reservation-visite',
  templateUrl: './modal-reservation-visite.component.html',
  styleUrls: ['./modal-reservation-visite.component.scss']
})
export class ModalReservationVisiteComponent implements OnInit, OnChanges {
  closeResult?: string;
  @Input() bien: Partial<any> = {}
  @Input() classCss?:any;
  @Input() textBtn?:any;

  agentBien: any;
  visitForm!: FormGroup;
  submitted = false;
  userConnected?: any = {};
  isPartnerV: any;

  constructor(
    private modalService: NgbModal,
    private _userService: UserService,
    private visitService: VisitService,
    private toastService: ToastService,
    private formBuilder: FormBuilder
  ) {
    this.userConnected = this._userService.getUser();
    this.checkPartner();
  }

  checkPartner() {
    if (this.userConnected) {
      this.isPartnerV = this.userConnected
        ? this.userConnected['type']['id'] === TYPE_USER.PARTNER
        : false;
    }
  }

  ngOnInit() {
    this.userConnected = this._userService.getUser();
    if (this.bien) {
      this.agentBien = this.bien.local_market_expert;
    }
    this.createVisitForm();
  }

  ngOnChanges(changements: SimpleChanges) {
    if (changements['bien'] && changements['bien'].currentValue) {
      this.agentBien = this.bien?.local_market_expert;
    }
  }

  createVisitForm() {
    this.visitForm = this.formBuilder.group({
      firstName: [(this.userConnected) ? this.userConnected.prenom : '', Validators.required],
      lastName: [(this.userConnected) ? this.userConnected.nom : '', Validators.required],
      phone: [(this.userConnected) ? this.userConnected.phone : null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10})$/)])],
      email: [(this.userConnected) ? this.userConnected.usermail : null, Validators.compose([Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)])],
      disponibility: ['', Validators.required],
      access: ['', (!this.isPartnerV) ? Validators.required : ''],
      saler: ['',  (!this.isPartnerV) ? Validators.required : ''],
      financier: ['',  (!this.isPartnerV) ? Validators.required : ''],
      contactTdm: [''],
      comment: [''],
      terms: ['',  (!this.isPartnerV) ? Validators.required : '']
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.visitForm.controls;
  }

  submitFormVisit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.visitForm.invalid) {
      return;
    }

    let newVisit = this.visitForm.value
    newVisit.responsible = this.agentBien?.id || this.bien?.local_market_expert?.id;
    newVisit.property = this.bien?.id;
    this.visitService.requestVisit(newVisit).pipe(first()).subscribe(
      response => {
        this.visitForm.reset();
        this.submitted = false;
        this.modalService.dismissAll();
        this.showSuccess('Votre demande de visite a bien été envoyée, nous vous remercions pour votre visite.');
      },
      err => {
        this.submitted = false;
        this.modalService.dismissAll();
        this.showDanger("Votre demande de visite n'a pas pu être envoyée, veuillez réessayer plus tard.");
      }
    );

  }

  showSuccess(message: any) {
    this.toastService.show(message, {
      classname: 'bg-success text-light',
      delay: 10000,
    });
  }

  showDanger(message: any) {
    this.toastService.show(message, {
      classname: 'bg-danger text-light',
      delay: 10000,
    });
  }


  openFullscreen(content: any) {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    this.modalService.open(content, { fullscreen: true });
  }

}
